import React from 'react';
import { observer } from 'mobx-react-lite';
import Animate from '../../../lib/animate';
import Icon from '../../../lib/icon';
const ErrorBar = function ErrorBar(props) {
    const { dataSet, prefixCls } = props;
    const { validationSelfErrors: error } = dataSet;
    const errorMessage = error && error.length ? error[0].message : undefined;
    const saveRef = (node) => {
        if (node) {
            node.focus();
        }
    };
    return (React.createElement(Animate, { transitionName: "slide-down", className: `${prefixCls}-error`, hiddenProp: "hidden", component: "div" }, errorMessage && (React.createElement("div", { ref: saveRef, hidden: !errorMessage, className: `${prefixCls}-error-content`, tabIndex: -1 },
        React.createElement("div", null,
            React.createElement(Icon, { type: "cancel" }),
            errorMessage),
        React.createElement(Icon, { type: "close", onClick: () => dataSet.clearValidationError() })))));
};
ErrorBar.displayName = 'ErrorBar';
export default observer(ErrorBar);
